import React, {useEffect} from "react";
import ProductCard from "../components/ProductCard";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useQuery } from "@tanstack/react-query";
import { itemApi } from "../../api"; // doğru path'e göre güncelle


const fetchTopProducts = async () => {
    const res = await itemApi.getItems({ limit: 10 });
    const items = res.data.items || res.data;


    const mappedItems = items.map((item) => {
        const sizes = item.variants?.map(v => v.size) || [];
        const coverImage = item.coverImage || item.images?.[0]?.coverImage || "/product-placeholder.png";


        const result = {
            name: item.name,
            slug: item.slug,
            category: item.category,
            totalPrice: item.totalPrice,
            isOutofSale: !item.isStock,
            sizes,
            coverImage
        };


        return result;
    });

    return mappedItems;
};



export default function Products({
                                     fullWidth = false,
                                     cardStyleClass,
                                     tooltipDirection,
                                     onLoaded,
                                 }) {
    const {
        data: products = [],
        isSuccess,
    } = useQuery({
        queryKey: ['home', 'top-products'],
        queryFn: fetchTopProducts,
        staleTime: 5 * 60 * 1000,
    });

    useEffect(() => {
        if (isSuccess && products.length > 0) {
            onLoaded?.();
        }
    }, [isSuccess, products]);

    return (
        <section className="flat-spacing-3 overflow-hidden">
            <div className="container">
                <div className="flat-title wow fadeInUp">
                    <h4 className="title">Best Sellers</h4>
                </div>
                <div className="fl-control-sw2 pos2 wow fadeInUp">
                    <Swiper
                        dir="ltr"
                        className="swiper tf-swiper wrap-sw-over"
                        modules={[Pagination, Navigation]}
                        {...{
                            slidesPerView: 2,
                            spaceBetween: 12,
                            speed: 800,
                            slidesPerGroup: 2,
                            navigation: {
                                clickable: true,
                                nextEl: ".nav-next-seller",
                                prevEl: ".nav-prev-seller",
                            },
                            pagination: { el: ".sw-pagination-seller", clickable: true },
                            breakpoints: {
                                768: { slidesPerView: 3, spaceBetween: 12, slidesPerGroup: 3 },
                                1200: { slidesPerView: 4, spaceBetween: 24, slidesPerGroup: 4 },
                            },
                        }}
                    >
                        {products.map((product) => (
                            <SwiperSlide className="swiper-slide" key={product.slug}>
                                <ProductCard product={product}  styleClass={cardStyleClass ? cardStyleClass : "grid style-1"}
                                             tooltipDirection={tooltipDirection}/>
                            </SwiperSlide>
                        ))}
                        <div className="d-flex d-xl-none sw-dot-default sw-pagination-seller justify-content-center mt_5" />
                    </Swiper>
                    <div className="d-none d-xl-flex swiper-button-next nav-swiper nav-next-seller" />
                    <div className="d-none d-xl-flex swiper-button-prev nav-swiper nav-prev-seller" />
                </div>
            </div>
        </section>
    );
}

